// src/auth/tokenStore.ts

// Ключи как в Blazor ProtectedLocalTokenStore
export const Keys = {
  Access: "jetrub.access",
  Refresh: "jetrub.refresh",
  ExpAt: "jetrub.expAt",
  Role: "jetrub.role",
  User: "jetrub.userId",
  Office: "jetrub.officeId",
  Name: "jetrub.username",
} as const;

export type TokenKey = (typeof Keys)[keyof typeof Keys];

const storage: Storage | null =
  typeof window !== "undefined" && typeof window.localStorage !== "undefined"
    ? window.localStorage
    : null;

// Небольшой ин-мемори фолбэк, если localStorage недоступен (SSR/приватный режим и т.п.)
const memory = new Map<string, string>();

export const tokenStore = {
  set(key: TokenKey, value: string): void {
    try {
      if (storage) storage.setItem(key, value);
      else memory.set(key, value);
    } catch {
      // игнорируем квоту/доступ
    }
  },

  get(key: TokenKey): string | null {
    try {
      if (storage) return storage.getItem(key);
      return memory.get(key) ?? null;
    } catch {
      return null;
    }
  },

  remove(key: TokenKey): void {
    try {
      if (storage) storage.removeItem(key);
      else memory.delete(key);
    } catch {
      // ignore
    }
  },

  clearAll(): void {
    try {
      for (const k of Object.values(Keys)) {
        if (storage) storage.removeItem(k);
        else memory.delete(k);
      }
    } catch {
      // ignore
    }
  },
};
